<template>
  <div v-loading="loadingFlag" class="chemical_pup">
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="100px"
      label-position="left"
      required
    >
      <el-form-item label="化学品:" prop="hxpBm">
        <!--  <span>{{ huaxuepin }}</span> -->
        <el-input v-model="huaxuepin" disabled />
        <i
          v-preventReClick
          class="el-icon-circle-plus-outline"
          style="cursor: pointer; position: absolute; right: 10px; top: 10px"
          @click="innerVisible = true"
        />
      </el-form-item>
      <el-form-item label="业务类型:" prop="ywlx">
        <el-select v-model="form.ywlx" placeholder="请选择" style="width: 100%">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <div style="display: flex; display: flex; justify-content: space-between">
        <el-form-item label="年涉及数量:" prop="nsjsl" style="flex-grow: 2">
          <el-input
            v-model="form.nsjsl"
            placeholder="请输入年涉数量"
          />
        </el-form-item>
        <el-form-item prop="nsjslDw">
          <el-select v-model="form.nsjslDw" placeholder="请选择">
            <el-option
              v-for="item in yzd_nsjsl_dw"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </div>
      <el-form-item label="用途:" prop="yt">
        <el-input v-model="form.yt" placeholder="请输入用途" />
      </el-form-item>
      <el-row v-if="isShowTestMenu" :gutter="20">
        <el-col :span="12">
          <el-form-item label="产品名称:">
            <el-input
              placeholder="请输入产品名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="包装形式:">
            <el-input
              placeholder="请输入包装形式"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="isShowTestMenu" :gutter="20">
        <el-col :span="12">
          <el-form-item label="产品形态:">
            <el-input
              placeholder="请输入产品形态"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="产品质量:">
            <el-input
              placeholder="请输入产品质量"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div style="text-align: center">
      <el-button v-preventReClick @click="close">取 消</el-button>
      <el-button
        v-preventReClick
        type="primary"
        style="background: #4170ff; margin-left: 40px"
        @click="chemicallShow"
      >确 定</el-button>
    </div>
    <!-- 内部dialog -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="30%"
      :visible.sync="innerVisible"
      append-to-body
      center
      custom-class="neibu"
      :show-close="false"
    >
      <!--  check-on-click-node -->
      <div style="overflow: auto; height: 100%">
        <el-tree
          ref="dataTree"
          check-strictly
          :data="HxpTree"
          show-checkbox
          node-key="value"
          :props="defaultProps"
          check-on-click-node
          @check-change="handleCheckChange"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          @click="innerVisible = false"
        >取 消</el-button>
        <el-button
          v-preventReClick
          type="primary"
          style="background: #4170ff; margin-left: 40px"
          @click="treeQ"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { lengthValidate } from '@/assets/js/validate.js'
import { getHxpTree, getkv } from '@/assets/js/common.js'
export default {
  components: {},
  props: {
    content: {
      type: Object
    },
    puptype: {
      type: String
    },
    source: {
      type: String,
      default: 'other'
    }
  },
  data() {
    const hxpJiaoyan = (rule, value, callback) => {
      if (!this.huaxuepin) {
        callback(new Error('请选择化学品!'))
      } else {
        callback()
      }
    }
    return {
      isShowTestMenu: false, // 开发环境
      loadingFlag: false,
      huaxuepin: '',
      yzd_nsjsl_dw: [
        {
          label: '吨',
          value: '1'
        },
        {
          label: '千克',
          value: '2'
        }
      ],
      options: [],
      HxpTree: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      dialogVisible: true,
      innerVisible: false,
      form: {
        id: '',
        hxpBm: '',
        nsjsl: '',
        nsjslDw: '',
        ywlx: '',
        yt: '',
        yzdHxpId: ''
      },
      rules: {
        ywlx: [{ required: true, message: '请输入业务类型', trigger: 'blur' }],
        hxpBm: [{ required: true, validator: hxpJiaoyan, trigger: 'blur' }],
        nsjsl: [
          {
            required: true,
            validator: function(rule, value, callback) {
              if (!value) {
                callback(new Error('请输入'))
              } else if (
                /^[1-9]\d{0,12}(\.\d{1,2})?$|^0(\.\d{1,2})?$/.test(value) ==
                false
              ) {
                callback(new Error('整数位最大长度13位,保留2位小数'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],

        yt: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 255)
            },
            trigger: ['blur', 'change']
          }
        ],
        nsjslDw: [{ required: true, message: '请选择单位', trigger: 'blur' }]
      }
    }
  },
  computed: {},
  watch: {},
  beforeDestroy() {
    // this.$refs.form.resetFields();
  },
  created() {
    // 编辑打开时展示行信息
    this.form.yt = this.content.yt
    this.form.ywlx = this.content.ywlx
    this.form.nsjslDw = this.content.nsjslDw
    this.form.nsjsl = this.content.nsjsl
    this.form.id = this.content.id
    this.form.hxpBm = this.content.hxpBm
    this.huaxuepin = this.content.hxpmc
    this.form.yzdHxpId = this.content.yzdHxpId

    // 化学品树
    getHxpTree().then((e) => {
      this.HxpTree = e.data.data
    })
    // 业务类型
    getkv('yzd_ywlx').then((e) => {
      this.options = e.data.data
    })
  },
  mounted() {
    this.isShowTestMenu = process.env.VUE_APP_SHOW_TEST_MENU === 'true'
  },
  methods: {
    lengthValidate,
    chemicallShow() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.loadingFlag = true
          if (this.source === 'qyjbxx') {
            this.$parent.$parent.baosunEditData(this.form)
          } else {
            if (this.puptype == 'add') {
              this.$parent.$parent.closePupop(this.form)
            }
            if (this.puptype == 'edit') {
              this.$parent.$parent.baosunEditData(this.form)
            }
          }
        } else {
          return false
        }
      })
    },
    close() {
      this.$parent.$parent.dialogVisible = false
    },

    treeQ() {
      const node = this.$refs.dataTree.getCheckedNodes()[0]
      // 有节点 并且 是最终节点的时候
      if (node && node.end) {
        this.form.yzdHxpId = node.value
        this.huaxuepin = node.label
        this.form.nsjslDw = node.dw
      } else {
        this.form.hxpBm = ''
        this.form.nsjslDw = ''
        this.huaxuepin = ''
      }
      this.innerVisible = false
    },

    handleCheckChange(data, checked, node) {
      if (checked) {
        // 实现单选功能
        this.$refs.dataTree.setCheckedKeys([data.value])
      }
    }
    /* nodeClick(data, checked, node) {
      if (data.children == undefined) {
        this.$refs.dataTree.setChecked(data.id, !checked.checked);
      }
    }, */
  }
}
</script>
<style lang='less' scoped>
/deep/.el-tree .el-tree-node .is-leaf + .el-checkbox .el-checkbox__inner {
  display: inline-block;
}
/deep/.el-tree .el-tree-node .el-checkbox .el-checkbox__inner {
  display: none;
}
.neibu {
  position: relative;
  margin: 0 auto 50px;
  border-radius: 2px;
  box-sizing: border-box;
  width: 50%;
  height: 373px;
  border-radius: 5px;
  .el-dialog__body {
    height: 74%;
    padding: 0;
    width: 85%;
    margin: auto;
  }
}
.chemical_pup_mask {
  .chemical_pup {
    .close {
      width: 15px;
      height: 15px;
      position: absolute;
      right: 30px;
      top: 30px;
      cursor: pointer;
    }
    .preservation {
      margin-top: 64px;
      text-align: center;
      .el-button--primary {
        color: #fff;
        border-color: #4170ff;
        width: 148px;
        height: 60px;
        background-color: #4170ff;
        font-size: 14px;
      }
    }
  }
}
</style>
